'use strict';

var template = require('../../templates/coupons/Row.ejs');
var RowEditView = require('commons/views/RowEdit');

module.exports = RowEditView.extend({
    tagName: 'tr',

    events: function() {
        var parentEvents = _.isFunction(RowEditView.prototype.events) ?
            RowEditView.prototype.events() :
            RowEditView.prototype.events;

        return _.extend(_.clone(parentEvents), {
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            deletable: true
        });
        return RowEditView.prototype.initialize.apply(this, [this.options]);
    },

    render: function() {
        var r = RowEditView.prototype.render.apply(this, arguments);
        setTimeout(this.initializeControls.bind(this), 1);
        return r;
    },

    initializeControls: function() {
        // The UI design has a weird placement for the delete button
        this.$('.form-control-with-delete').each(function(i, control) {
            var $control = this.$(control);
            var $value = $control.find('.form-control-value');
            var $input = $control.find('.form-control');

            $value.css({
                display: 'inline-block',
                maxWidth: (
                    $input.width() -
                    $control.find('.btn-delete').outerWidth(true) - 5
                ) + 'px'
            }).text($input.val());

            $value.on('click', function() {
                $control.addClass('focus');
                $input.focus();
            });

            $input.on('keyup', function(ev) {
                var val = this.$(ev.target).val();
                $value.html(val);
            }.bind(this))
            .on('focus', function() {
                $control.addClass('focus');
            })
            .on('blur', function() {
                $control.removeClass('focus');
            });
        }.bind(this));
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/coupons/Row.js